var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _path34, _path35, _path36, _path37, _path38, _path39, _path40, _path41, _path42, _path43, _path44, _path45, _path46, _path47, _path48, _path49, _path50, _path51, _path52, _path53, _path54, _path55, _path56, _path57, _path58, _path59, _path60, _path61, _path62, _path63, _path64, _path65, _path66, _path67, _path68, _path69, _path70, _path71, _path72, _path73, _path74, _path75, _path76, _path77, _path78, _path79, _path80, _path81, _path82, _path83, _path84, _path85, _line;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSittingRoom(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 491,
    height: 553,
    viewBox: "0 0 491 553",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M274.717 141.698H32.063C21.1633 141.698 12.3274 150.534 12.3274 161.434V404.088C12.3274 414.988 21.1633 423.824 32.063 423.824H274.717C285.617 423.824 294.453 414.988 294.453 404.088V161.434C294.453 150.534 285.617 141.698 274.717 141.698Z",
    fill: "#F5EBDD"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M241.753 133.26C245.514 133.26 248.562 130.211 248.562 126.451C248.562 122.69 245.514 119.641 241.753 119.641C237.992 119.641 234.943 122.69 234.943 126.451C234.943 130.211 237.992 133.26 241.753 133.26Z",
    fill: "#A15842"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M241.753 102.779V124.183",
    stroke: "#A15842",
    strokeWidth: 4,
    strokeMiterlimit: 10
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M271.097 109.918H260.735V199.418H271.097V109.918Z",
    fill: "#A15842"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M296.761 36.123C294.688 40.2209 285.995 54.5264 265.916 54.5264C245.837 54.5264 237.15 40.2209 235.071 36.123L215.658 109.918H316.18L296.761 36.123Z",
    fill: "#FFBE21"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M288.384 37.5564L301.437 109.932",
    stroke: "#F5EBDD",
    strokeWidth: 4,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M243.455 38.4983L230.57 109.931",
    stroke: "#F5EBDD",
    strokeWidth: 4,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M257.451 38.0339L252.458 109.904",
    stroke: "#F5EBDD",
    strokeWidth: 4,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M274.381 38.0339L279.387 110.046",
    stroke: "#F5EBDD",
    strokeWidth: 4,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M265.943 54.5197C286.029 54.5197 294.716 40.2142 296.788 36.1164V35.9751H235.112L235.072 36.1164C237.151 40.221 245.838 54.5197 265.943 54.5197Z",
    fill: "#FF7235"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M660.608 3.54883H417.954C407.054 3.54883 398.218 12.3848 398.218 23.2844V265.939C398.218 276.839 407.054 285.675 417.954 285.675H660.608C671.508 285.675 680.344 276.839 680.344 265.939V23.2844C680.344 12.3848 671.508 3.54883 660.608 3.54883Z",
    fill: "#F5EBDD"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M265.586 550.285C263.714 550.286 261.907 549.603 260.504 548.363C259.101 547.124 258.199 545.414 257.969 543.557L252.29 495.843H278.883L273.203 543.557C272.975 545.415 272.074 547.125 270.671 548.365C269.267 549.605 267.459 550.288 265.586 550.285Z",
    fill: "#30242A"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M109.559 298.648H228.935V496.475H55.1294V353.07C55.1312 338.636 60.8665 324.793 71.0738 314.587C81.281 304.381 95.1244 298.648 109.559 298.648Z",
    fill: "#BEC120"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M243.159 199.418H654.451C668.887 199.418 682.731 205.152 692.939 215.36C703.146 225.567 708.88 239.412 708.88 253.847V496.455H188.743V253.841C188.743 239.405 194.478 225.561 204.685 215.353C214.893 205.146 228.737 199.411 243.173 199.411L243.159 199.418Z",
    fill: "#BEC120"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M188.73 327.797V496.455",
    stroke: "#A15842",
    strokeWidth: 4,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M243.159 377.772H654.451C668.887 377.772 682.731 383.506 692.939 393.714C703.146 403.921 708.88 417.766 708.88 432.201V496.461H188.743V432.201C188.743 417.768 194.476 403.926 204.68 393.719C214.885 383.511 228.726 377.775 243.159 377.772Z",
    fill: "#BEC120"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M494.615 377.772H241.194C227.275 377.772 213.925 383.301 204.082 393.144C194.239 402.987 188.71 416.337 188.71 430.257V496.482",
    stroke: "#A15842",
    strokeWidth: 4,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M152.414 276.571C167.978 278.515 172.83 271.908 175.111 266.195C177.701 259.715 176.033 254.143 174.014 246.903C174.014 246.903 179.155 244.104 178.354 240.894C177.681 238.304 171.834 238.015 171.834 238.015C171.605 236.857 171.401 235.657 171.221 234.415C169.923 225.331 167.978 220.143 167.978 220.143C163.436 221.441 157.602 220.816 155.658 220.143C153.031 227.421 148.288 233.748 142.039 238.311C142.039 238.311 127.767 222.747 118.69 234.421C111.288 243.943 121.933 255.819 129.065 257.118C124.826 266.06 113.421 271.248 107.486 273.415C107.849 276.227 108.193 278.838 108.495 281.113H152.906L152.414 276.571Z",
    fill: "#EAA58B"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M306.874 333.039C309.218 324.705 311.131 316.255 312.607 307.725L297.043 265.569C297.043 265.569 303.53 248.074 297.716 245.463C291.903 242.852 278.882 259.748 273.695 273.354C271.454 279.235 265.331 292.753 259.106 306.204L306.874 333.039Z",
    fill: "#EAA58B"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M242.56 341.45C242.56 341.45 204.946 309.67 188.663 297.988C172.379 286.307 153.713 288.272 153.713 288.272L152.899 281.133H108.489C109.162 286.2 109.599 289.564 109.599 289.564L76.5337 407.608L175.104 399.822L172.513 363.487C172.513 363.487 225.671 407.897 256.18 403.698C283.694 399.89 299.325 360.163 306.868 333.046L259.093 306.211C250.931 323.881 242.56 341.45 242.56 341.45Z",
    fill: "#3EC1F3"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M129.066 257.138C121.933 255.839 111.282 243.963 118.69 234.441C127.767 222.767 142.039 238.331 142.039 238.331C148.289 233.768 153.031 227.441 155.658 220.163C157.603 220.836 163.437 221.461 167.979 220.163C167.979 220.163 177.709 216.919 177.056 209.141C176.188 198.698 160.193 203.3 160.193 203.3C160.193 203.3 142.699 190.327 123.858 198.758C103.779 207.795 101.828 226.01 103.106 238.331C103.846 245.403 105.872 261.209 107.466 273.435C113.421 271.261 124.827 266.08 129.066 257.138Z",
    fill: "#30242A"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M309.452 315.833C306.484 317.058 303.88 317.414 302.723 316.748C299.816 315.093 299.359 311.628 302.81 306.756C302.81 306.756 294.608 309.952 292.078 305.794C289.548 301.635 293.35 297.807 293.35 297.807C293.35 297.807 287.543 299.408 286.123 294.24C284.703 289.073 289.487 286.368 289.487 286.368C289.487 286.368 286.217 285.15 286.123 281.738C285.995 276.779 294.076 272.755 296.405 271.699",
    stroke: "#A15842",
    strokeWidth: 8,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M173.947 363.345L171.545 335.293",
    stroke: "#4756DF",
    strokeWidth: 4,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M151.802 277.768C148.039 276.917 144.415 275.54 141.036 273.677",
    stroke: "#A15842",
    strokeWidth: 4,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M80.7456 398.846L97.46 354.403",
    stroke: "#4756DF",
    strokeWidth: 4,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M168.725 253.551C167.655 254.224 163.631 254.735 161.996 251.647",
    stroke: "#A15842",
    strokeWidth: 4,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M162.79 238.977C163.864 238.977 164.735 238.106 164.735 237.032C164.735 235.958 163.864 235.087 162.79 235.087C161.716 235.087 160.846 235.958 160.846 237.032C160.846 238.106 161.716 238.977 162.79 238.977Z",
    fill: "#A15842"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "M127.121 242.873L134.254 246.762",
    stroke: "#A15842",
    strokeWidth: 4,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    d: "M309.075 523.881L358.754 509.179C354.965 496.085 347.718 471.262 343.055 456.802L281.063 482.681C289.175 497.209 298.548 510.995 309.075 523.881Z",
    fill: "#EAA58B"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    d: "M310.017 524.992C308.563 530.512 307.661 536.162 307.325 541.861H395.21C393.524 537.803 390.531 534.426 386.705 532.265L361.25 517.852C361.25 517.852 360.281 514.488 358.754 509.172L309.075 523.881C309.68 524.608 310.017 524.992 310.017 524.992Z",
    fill: "#FFBE21"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    d: "M307.419 550.285H396.913L396.637 547.513C396.443 545.568 395.96 543.663 395.204 541.861H307.319C307.126 544.667 307.159 547.484 307.419 550.285Z",
    fill: "#FF7235"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    d: "M263.319 441.332C267.612 456.136 274.186 470.34 281.063 482.681L343.056 456.802C342.383 454.628 341.71 452.691 341.145 451.055C321.745 394.998 310.017 349.915 281.48 345.346C236.565 338.2 160.16 415.554 148.687 427.437L165.213 437.456L217.173 461.862L236.101 466.229L263.319 441.332Z",
    fill: "#A15842"
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    d: "M261.906 440.754C260.435 433.581 259.713 426.274 259.753 418.952",
    stroke: "#30242A",
    strokeWidth: 4,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    d: "M502.636 287.619C502.636 287.619 440.482 304.017 413.143 319.399C382.009 336.894 380.064 360.257 360.611 419.275C354.347 438.271 349.919 453.532 345.808 465.522L399.396 490.823L399.497 490.621C399.497 490.621 425.739 486.765 428.034 454.285C429.763 430.061 430.591 412.089 439.056 393.968L583.685 287.606L502.636 287.619Z",
    fill: "#30242A"
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    d: "M316.914 501.151C298.174 503.991 290.355 507.638 287.307 516.137L322.707 532.615C322.707 532.615 341.689 527.232 351.91 529.863V529.897C358.757 531.503 365.441 533.74 371.875 536.579C382.422 522.183 391.655 506.869 399.463 490.823L345.875 465.522C338.19 487.963 331.785 498.897 316.914 501.151Z",
    fill: "#023527"
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    d: "M343.385 542.251L360.651 550.285C364.639 545.935 368.373 541.359 371.834 536.579C365.4 533.74 358.717 531.503 351.87 529.897L343.385 542.251Z",
    fill: "#30242A"
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    d: "M334.523 487.169L346.541 492.424",
    stroke: "#F5EBDD",
    strokeWidth: 4,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    d: "M327.693 495.506L339.711 500.768",
    stroke: "#F5EBDD",
    strokeWidth: 4,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    d: "M455.292 212.391C455.292 212.391 421.291 165.962 413.136 156.609C404.052 146.233 391.732 135.212 387.842 139.114C383.953 143.017 394.975 155.977 394.975 155.977L393.03 198.133C393.03 198.133 415.37 258.376 439.728 266.235C451.907 270.165 475.041 259.802 491.385 251.028L466.105 205.272C459.679 209.484 455.292 212.391 455.292 212.391Z",
    fill: "#A15842"
  })), _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    d: "M638.188 216.926C638.188 216.926 635.59 202.661 632.347 194.876C627.496 183.222 619.488 173.344 602.794 170.208C598.905 179.433 583.583 210.346 553.223 209.794C529.389 209.363 522.64 187.219 520.783 172.563C518.795 173.171 516.848 173.908 514.956 174.77C508.113 177.966 481.366 195.286 466.105 205.272L491.358 251.001C501.983 245.302 509.741 240.235 509.741 240.235L502.609 287.579H592.775L598.898 285.183L641.29 256.424C641.235 243.2 640.198 229.997 638.188 216.926Z",
    fill: "#FF7235"
  })), _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
    d: "M399.174 206.887C400.229 206.878 401.254 206.534 402.101 205.905C404.395 203.61 403.931 200.253 399.45 196.592C399.45 196.592 407.941 197.474 409.233 192.932C410.525 188.39 405.997 185.799 405.997 185.799C405.997 185.799 411.831 185.799 411.831 180.611C411.831 175.423 406.643 174.125 406.643 174.125C406.643 174.125 409.388 172.14 408.587 168.937C407.289 163.749 396.267 162.45 396.267 162.45L394.746 160.593",
    stroke: "#30242A",
    strokeWidth: 8,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path42 || (_path42 = /*#__PURE__*/React.createElement("path", {
    d: "M456.907 212.243L463.723 221.468",
    stroke: "#30242A",
    strokeWidth: 4,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path43 || (_path43 = /*#__PURE__*/React.createElement("path", {
    d: "M550.633 288.272C550.633 288.272 494.851 305.767 463.723 320.698C432.771 335.501 436.485 369.987 442.319 430.304C444.385 451.627 446.8 468.321 448.025 481.544H507.239C510.28 479.848 528.233 468.321 517.527 436.79C509.708 413.771 502.959 398.523 502.959 378.525H552.483C566.571 378.526 580.104 373.034 590.207 363.216C600.31 353.398 606.187 340.028 606.59 325.946L607.673 288.265L550.633 288.272Z",
    fill: "#30242A"
  })), _path44 || (_path44 = /*#__PURE__*/React.createElement("path", {
    d: "M436.734 524.191C420.961 534.701 415.424 541.309 416.244 550.305L455.272 550.251C455.272 550.251 470.189 537.339 480.565 535.394C487.441 534.088 494.426 533.437 501.425 533.45C503.8 521.815 506.357 504.354 506.808 481.786L507.238 481.564H448.025C450.09 503.755 448.778 516.15 436.734 524.191Z",
    fill: "#023527"
  })), _path45 || (_path45 = /*#__PURE__*/React.createElement("path", {
    d: "M478.123 550.191H497.172C497.172 550.191 499.245 544.398 501.478 533.456C494.48 533.444 487.495 534.095 480.619 535.401L478.123 550.191Z",
    fill: "#30242A"
  })), _path46 || (_path46 = /*#__PURE__*/React.createElement("path", {
    d: "M502.36 379.717H487.072",
    stroke: "black",
    strokeWidth: 4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path47 || (_path47 = /*#__PURE__*/React.createElement("path", {
    d: "M446.834 507.16H461.455",
    stroke: "#F5EBDD",
    strokeWidth: 4,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path48 || (_path48 = /*#__PURE__*/React.createElement("path", {
    d: "M443.584 517.536H458.205",
    stroke: "#F5EBDD",
    strokeWidth: 4,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path49 || (_path49 = /*#__PURE__*/React.createElement("path", {
    d: "M246.134 404.357C262.072 404.357 274.993 391.436 274.993 375.497C274.993 359.559 262.072 346.638 246.134 346.638C230.195 346.638 217.274 359.559 217.274 375.497C217.274 391.436 230.195 404.357 246.134 404.357Z",
    fill: "white"
  })), _path50 || (_path50 = /*#__PURE__*/React.createElement("path", {
    d: "M254.242 366.743C254.242 362.265 250.611 358.635 246.133 358.635C241.655 358.635 238.025 362.265 238.025 366.743V376.466C238.025 380.945 241.655 384.575 246.133 384.575C250.611 384.575 254.242 380.945 254.242 376.466V366.743Z",
    fill: "#023527"
  })), _path51 || (_path51 = /*#__PURE__*/React.createElement("path", {
    d: "M246.133 381.984V391.068",
    stroke: "#023527",
    strokeWidth: 4,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path52 || (_path52 = /*#__PURE__*/React.createElement("path", {
    d: "M241.484 391.068H250.777",
    stroke: "#023527",
    strokeWidth: 4,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path53 || (_path53 = /*#__PURE__*/React.createElement("path", {
    d: "M42.4793 182.549C48.3881 182.549 53.1781 177.759 53.1781 171.85C53.1781 165.941 48.3881 161.151 42.4793 161.151C36.5705 161.151 31.7805 165.941 31.7805 171.85C31.7805 177.759 36.5705 182.549 42.4793 182.549Z",
    fill: "white"
  })), _path54 || (_path54 = /*#__PURE__*/React.createElement("path", {
    d: "M74.9122 182.549C80.821 182.549 85.611 177.759 85.611 171.85C85.611 165.941 80.821 161.151 74.9122 161.151C69.0034 161.151 64.2134 165.941 64.2134 171.85C64.2134 177.759 69.0034 182.549 74.9122 182.549Z",
    fill: "white"
  })), _path55 || (_path55 = /*#__PURE__*/React.createElement("path", {
    d: "M107.338 182.549C113.247 182.549 118.037 177.759 118.037 171.85C118.037 165.941 113.247 161.151 107.338 161.151C101.429 161.151 96.6392 165.941 96.6392 171.85C96.6392 177.759 101.429 182.549 107.338 182.549Z",
    fill: "white"
  })), _path56 || (_path56 = /*#__PURE__*/React.createElement("path", {
    d: "M274.69 141.698C279.923 141.698 284.941 143.777 288.641 147.477C292.341 151.177 294.419 156.195 294.419 161.427V404.088C294.419 409.321 292.341 414.339 288.641 418.039C284.941 421.739 279.923 423.817 274.69 423.817H32.0562C26.8237 423.817 21.8056 421.739 18.1057 418.039C14.4058 414.339 12.3273 409.321 12.3273 404.088V161.427C12.3273 156.195 14.4058 151.177 18.1057 147.477C21.8056 143.777 26.8237 141.698 32.0562 141.698H274.69ZM274.69 139.007H32.0562C26.1121 139.014 20.4135 141.378 16.2104 145.581C12.0073 149.784 9.64287 155.483 9.63574 161.427V404.088C9.64287 410.032 12.0073 415.731 16.2104 419.934C20.4135 424.137 26.1121 426.502 32.0562 426.509H274.69C280.635 426.502 286.333 424.137 290.536 419.934C294.739 415.731 297.104 410.032 297.111 404.088V161.427C297.104 155.483 294.739 149.784 290.536 145.581C286.333 141.378 280.635 139.014 274.69 139.007Z",
    fill: "#F5EBDD"
  })), _path57 || (_path57 = /*#__PURE__*/React.createElement("path", {
    d: "M428.377 44.4062C434.286 44.4062 439.076 39.6162 439.076 33.7074C439.076 27.7986 434.286 23.0085 428.377 23.0085C422.468 23.0085 417.678 27.7986 417.678 33.7074C417.678 39.6162 422.468 44.4062 428.377 44.4062Z",
    fill: "white"
  })), _path58 || (_path58 = /*#__PURE__*/React.createElement("path", {
    d: "M460.803 44.4062C466.712 44.4062 471.502 39.6162 471.502 33.7074C471.502 27.7986 466.712 23.0085 460.803 23.0085C454.895 23.0085 450.104 27.7986 450.104 33.7074C450.104 39.6162 454.895 44.4062 460.803 44.4062Z",
    fill: "white"
  })), _path59 || (_path59 = /*#__PURE__*/React.createElement("path", {
    d: "M493.229 44.4062C499.138 44.4062 503.928 39.6162 503.928 33.7074C503.928 27.7986 499.138 23.0085 493.229 23.0085C487.32 23.0085 482.53 27.7986 482.53 33.7074C482.53 39.6162 487.32 44.4062 493.229 44.4062Z",
    fill: "white"
  })), _path60 || (_path60 = /*#__PURE__*/React.createElement("path", {
    d: "M660.608 3.54895C665.843 3.54895 670.862 5.62823 674.564 9.32938C678.265 13.0305 680.344 18.0504 680.344 23.2846V265.946C680.342 271.179 678.262 276.197 674.561 279.897C670.86 283.596 665.842 285.675 660.608 285.675H417.954C412.721 285.675 407.702 283.596 404.001 279.897C400.3 276.197 398.22 271.179 398.218 265.946V23.2846C398.218 20.6928 398.729 18.1265 399.721 15.7321C400.712 13.3376 402.166 11.162 403.999 9.32938C405.831 7.49676 408.007 6.04304 410.402 5.05124C412.796 4.05943 415.362 3.54895 417.954 3.54895H660.608ZM660.608 0.857422H417.954C412.008 0.864545 406.308 3.22968 402.103 7.43404C397.899 11.6384 395.534 17.3387 395.527 23.2846V265.946C395.534 271.891 397.899 277.591 402.104 281.794C406.308 285.997 412.009 288.361 417.954 288.366H660.608C666.554 288.361 672.254 285.997 676.459 281.794C680.663 277.591 683.028 271.891 683.036 265.946V23.2846C683.028 17.3387 680.663 11.6384 676.459 7.43404C672.255 3.22968 666.554 0.864545 660.608 0.857422Z",
    fill: "#F5EBDD"
  })), _path61 || (_path61 = /*#__PURE__*/React.createElement("path", {
    d: "M395.621 155.963C395.621 155.963 381.355 155.963 379.411 161.797C377.466 167.631 382.001 172.18 382.001 172.18C382.001 172.18 374.223 176.069 379.411 183.202C379.411 183.202 375.515 189.688 382.001 193.577C382.001 193.577 378.112 198.119 384.599 202.661C391.085 207.203 400.163 207.849 402.094 205.905C404.388 203.61 403.924 200.252 399.443 196.592C399.443 196.592 407.934 197.473 409.226 192.931C410.518 188.39 405.99 185.799 405.99 185.799C405.99 185.799 411.824 185.799 411.824 180.611C411.824 175.423 406.636 174.124 406.636 174.124C406.636 174.124 409.381 172.139 408.58 168.937C407.625 165.121 401.421 163.412 398.198 162.773C397.341 162.615 396.476 162.507 395.607 162.45L395.621 155.963Z",
    fill: "#A15842"
  })), _path62 || (_path62 = /*#__PURE__*/React.createElement("path", {
    d: "M382.749 194.122C389.192 196.07 395.827 197.318 402.538 197.843",
    stroke: "#30242A",
    strokeWidth: 4,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path63 || (_path63 = /*#__PURE__*/React.createElement("path", {
    d: "M380.333 183.713C389.721 186.036 399.388 187.03 409.052 186.667",
    stroke: "#30242A",
    strokeWidth: 4,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path64 || (_path64 = /*#__PURE__*/React.createElement("path", {
    d: "M382.385 172.947C391.284 175.084 400.485 175.671 409.583 174.683",
    stroke: "#30242A",
    strokeWidth: 4,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path65 || (_path65 = /*#__PURE__*/React.createElement("path", {
    d: "M590.837 279.215C590.837 279.215 538.306 292.841 520.145 306.46C511.942 312.61 501.977 323.955 498.747 329.156C495.517 334.358 481.884 353.804 488.371 354.45C494.858 355.096 501.99 343.428 501.99 343.428C501.99 343.428 498.087 357.693 498.76 362.235C499.433 366.777 505.893 365.478 505.893 365.478C511.081 370.666 515.623 364.18 515.623 364.18C524.7 370.014 534.463 338.886 534.463 338.886C539.79 336.261 544.706 332.874 549.058 328.833C549.058 328.833 607.101 328.51 625.262 312.294C638.154 300.788 641.337 278.091 641.33 256.492H590.864L590.837 279.215Z",
    fill: "#A15842"
  })), _path66 || (_path66 = /*#__PURE__*/React.createElement("path", {
    d: "M510.522 301.918C494.716 307.543 477.073 314.299 463.723 320.698C439.796 332.137 436.586 355.358 439.055 393.154",
    stroke: "black",
    strokeWidth: 4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path67 || (_path67 = /*#__PURE__*/React.createElement("path", {
    d: "M130.404 488.051C103.873 493.434 84.9647 500.351 84.9647 500.351L59.4356 489.04L59.4894 488.481L0 542.507L1.29866 544.061C2.92251 546.009 4.95455 547.576 7.251 548.652C9.54746 549.727 12.0522 550.285 14.5881 550.285H133.991L130.404 488.051Z",
    fill: "#EAA58B"
  })), _path68 || (_path68 = /*#__PURE__*/React.createElement("path", {
    d: "M84.9377 500.351C84.9377 500.351 103.846 493.4 130.377 488.05L133.964 550.285H219.184C242.224 550.285 262.417 534.136 266.71 511.5C269.57 496.394 265.102 480.218 249.047 469.216C223.222 451.52 167.978 428.359 153.713 423.817L75.2348 441.985C60.317 458.201 63.5603 484.787 63.5603 484.787L84.9377 500.351Z",
    fill: "#A15842"
  })), _path69 || (_path69 = /*#__PURE__*/React.createElement("path", {
    d: "M130.6 488.891C148.243 485.48 167.952 482.526 195.54 483.811",
    stroke: "#30242A",
    strokeWidth: 4,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path70 || (_path70 = /*#__PURE__*/React.createElement("path", {
    d: "M155.059 423.144C167.541 427.121 211.399 445.349 239.465 461.7",
    stroke: "#30242A",
    strokeWidth: 4,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path71 || (_path71 = /*#__PURE__*/React.createElement("path", {
    d: "M72.1533 488.952L6.68872 548.361C9.1368 549.626 11.8527 550.286 14.6085 550.285H62.262L84.9381 500.351C81.3866 495.823 77.0575 491.963 72.1533 488.952Z",
    fill: "#FFBE21"
  })), _path72 || (_path72 = /*#__PURE__*/React.createElement("path", {
    d: "M63.5604 484.78L0 542.507L1.29866 544.061C2.78529 545.842 4.61623 547.305 6.68171 548.361L72.1531 488.952C69.4517 487.248 66.5699 485.849 63.5604 484.78Z",
    fill: "#FF7235"
  })), _path73 || (_path73 = /*#__PURE__*/React.createElement("path", {
    d: "M48.9658 538.94V550.433",
    stroke: "#30242A",
    strokeWidth: 4,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path74 || (_path74 = /*#__PURE__*/React.createElement("path", {
    d: "M38.5901 538.94V550.433",
    stroke: "#30242A",
    strokeWidth: 4,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path75 || (_path75 = /*#__PURE__*/React.createElement("path", {
    d: "M109.868 288.474C111.887 288.285 116.099 287.942 120.312 287.942",
    stroke: "#4756DF",
    strokeWidth: 4,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path76 || (_path76 = /*#__PURE__*/React.createElement("path", {
    d: "M297.044 265.569C297.044 265.569 309.694 261.377 313.193 266.652C316.692 271.928 313.448 277.688 313.448 277.688C313.448 277.688 322.256 279.43 319.047 287.949C319.047 287.949 324.692 293.332 319.309 298.984C319.309 298.984 324.423 302.436 319.208 308.728C313.993 315.019 305.145 318.148 302.676 316.748C299.769 315.093 299.311 311.628 302.763 306.756C302.763 306.756 294.561 309.952 292.031 305.794C289.501 301.635 293.302 297.807 293.302 297.807C293.302 297.807 287.495 299.408 286.076 294.24C284.656 289.073 289.44 286.368 289.44 286.368C289.44 286.368 286.17 285.15 286.076 281.738C285.948 276.779 294.648 272.459 296.976 271.41L297.044 265.569Z",
    fill: "#EAA58B"
  })), _path77 || (_path77 = /*#__PURE__*/React.createElement("path", {
    d: "M287.476 287.276C292.468 286.401 305.152 283.696 313.55 277.856",
    stroke: "#A15842",
    strokeWidth: 4,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path78 || (_path78 = /*#__PURE__*/React.createElement("path", {
    d: "M289.494 299.395C300.038 298.074 310.153 294.414 319.101 288.682",
    stroke: "#A15842",
    strokeWidth: 4,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path79 || (_path79 = /*#__PURE__*/React.createElement("path", {
    d: "M298.915 309.266C300.711 308.633 312.433 304.428 319.545 299.919",
    stroke: "#A15842",
    strokeWidth: 4,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path80 || (_path80 = /*#__PURE__*/React.createElement("path", {
    d: "M119.369 392.306C107.627 393.739 94.5264 395.859 79.7768 398.497L100.529 342.721L109.606 289.564C109.606 289.564 79.7769 292.807 66.1577 308.405C53.595 322.757 14.2718 389.473 29.8221 424.497C45.3724 459.52 92.0973 447.166 103.106 443.923C109.114 442.153 118.219 438.076 127.565 435.041L119.369 392.306Z",
    fill: "#3EC1F3"
  })), _path81 || (_path81 = /*#__PURE__*/React.createElement("path", {
    d: "M149.818 431.603C164.089 433.547 180.299 440.68 182.896 431.603C182.896 431.603 191.644 431.381 188.885 423.064C188.885 423.064 193.272 422.519 193.918 419.275C195.217 412.796 179.653 406.955 179.653 406.955C179.653 406.955 191.974 408.9 194.571 406.282C197.875 402.971 194.658 397.703 174.532 392.824C159.917 389.285 142.234 389.5 119.356 392.3L127.572 435.007C135.404 432.518 143.331 430.714 149.818 431.603Z",
    fill: "#EAA58B"
  })), _path82 || (_path82 = /*#__PURE__*/React.createElement("path", {
    d: "M185.197 407.782C178.287 405.131 165.166 400.724 155.658 399.176",
    stroke: "#A15842",
    strokeWidth: 4,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path83 || (_path83 = /*#__PURE__*/React.createElement("path", {
    d: "M189.154 422.794C180.137 418.757 162.723 411.275 153.384 409.875",
    stroke: "#A15842",
    strokeWidth: 4,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path84 || (_path84 = /*#__PURE__*/React.createElement("path", {
    d: "M182.163 432.275C175.212 428.749 161.303 422.128 151.439 420.251",
    stroke: "#A15842",
    strokeWidth: 4,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path85 || (_path85 = /*#__PURE__*/React.createElement("path", {
    d: "M119.484 393.275C113.146 394.096 92.8716 396.895 62.5852 402.742",
    stroke: "#4756DF",
    strokeWidth: 4,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _line || (_line = /*#__PURE__*/React.createElement("line", {
    opacity: 0.2,
    x1: 160.819,
    y1: 91.0283,
    x2: 594.827,
    y2: 91.0283,
    stroke: "black",
    strokeDasharray: "5 5"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSittingRoom);
export default __webpack_public_path__ + "static/media/sitting-room.5d79da2e4d0d870a6d3009d5551eaea1.svg";
export { ForwardRef as ReactComponent };